// Optimized getValue without regex inside sort
const parsePath = (path) => {
    return path
        .replace(/\?\.\s*/g, ".")     // remove ?.
        .replace(/\?\[\s*/g, "[")     // remove ?[
        .replace(/\[(\d+)\]/g, ".$1") // convert [0] → .0
        .split(".")
        .filter(Boolean);
};

const getValueFast = (obj, keys) => {
    return keys.reduce((acc, key) => (acc ? acc[key] : undefined), obj);
};

// Pre-optimized string compare
const compareString = (a, b) =>
    a.localeCompare(b);

// Predefined converters — fast & clean
const valueTransform = {
    string: (v) => (v == null ? "" : String(v).toLowerCase()),
    number: (v) => Number(v),
    date: (v) => (v ? new Date(v).getTime() : 0),
};


/**
 * @typedef {"string" | "number" | "date"} DataType
 * @param {Array} data
 * @param {boolean} isAscending
 * @param {string} column
 * @param {DataType} dataType
 */

export const getSortedData = (data, isAscending, column, dataType) => {
    if (!Array.isArray(data)) return [];

    const keys = parsePath(column);

    // Pre-cache values for each row (BIG SPEED BOOST)
    const mapped = [...data]?.map((item) => {
        const raw = getValueFast(item, keys);

        // Use transform function directly (much cleaner)
        const value = valueTransform?.[dataType]?.(raw);

        return { item, value };
    });

    // Sorting using precomputed values → very fast
    mapped?.sort((a, b) => {
        const diff =
            dataType === "string"
                ? compareString(a?.value, b?.value)
                : a?.value - b?.value;

        return isAscending ? diff : -diff;
    });

    // Return sorted original objects
    return mapped?.map((x) => x?.item);
};
